/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-03-12 12:02:41
 * @LastEditors: 刘洪壮 liuhongzhuang@nextmar.com
 * @LastEditTime: 2025-04-21 11:21:45
 * @FilePath: /zeelool-nextjs/src/store/slices/userSlice.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { StateCreator } from 'zustand';

import { Store } from '@/store';

export interface SurveyState {
  surveyDetailShow: boolean;
  surveyInfo: any;
}

export interface SurveyActions {
  setSurveyDetailShow: (surveyDetailShow: SurveyState['surveyDetailShow']) => void;
  setSurveyInfo: (surveyInfo: SurveyState['surveyInfo']) => void;
}

export type SurveySlice = SurveyState & SurveyActions;

export const initialSurveyState: SurveyState = {
  surveyDetailShow: false,
  surveyInfo: {},
};

export const createSurveySlice: StateCreator<Store, [], [], SurveySlice> = (set) => ({
  ...initialSurveyState,
  setSurveyDetailShow: (surveyDetailShow) => set({ surveyDetailShow }),
  setSurveyInfo: (surveyInfo) => {
    set({ surveyInfo });
    const setLocal = function (key: string, value: any) {
      localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
    };
    setLocal('zl-surveyInfo', surveyInfo);
  },
});
